import { render, staticRenderFns } from "./SkupSuorganizatorForma.vue?vue&type=template&id=7c7986e4&scoped=true&"
import script from "./SkupSuorganizatorForma.vue?vue&type=script&lang=js&"
export * from "./SkupSuorganizatorForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7986e4",
  null
  
)

export default component.exports